package com.example.borshi.web.model

/**
 * Nutritionist profile with credentials and information (JS/WEB version)
 */
data class NutritionistProfile(
    val nutritionistId: String = "",
    val name: String = "",
    val specialization: String = "",
    val qualifications: String = "",
    val bio: String = "",
    val profileImage: String = "",
    val experienceYears: Int = 0,
    val rating: Double = 0.0,
    val totalClients: Int = 0
)
